import React from "react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import { SingleBarSettingsStateType, defaultSettings } from "./SingleBarSettings";
import TitleCase from "components/formatting/TitleCase";

interface SingleBarPreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: SingleBarSettingsStateType | {};
}

export default function SingleBarPreview(props: SingleBarPreviewProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentState = {...defaultSettings, ...props.settingsState};
  const fillWidth = `${(.50 * 100).toFixed(2)}%`;
  const fillColor = currentState.fillColor || theme.palette.primary.main;

  return (
    <Stack sx={{
      width: isSmallScreen ? '100%' : '50%'
    }}>
      <Stack
        direction={currentState.widgetTitleAlignment === 'right' ? 'row-reverse' : 'row'}
        sx={{
          justifyContent: currentState.widgetTitleAlignment === 'center' ? 'center' : 'space-between'
        }}
      >
        {currentState.widgetTitle !== 'none' &&
          <Typography
            sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
            variant="subtitle2">
            <TitleCase text={currentState.widgetTitle} />
          </Typography>}
        {currentState.showDataValue &&
          <Typography
            variant="subtitle2"
            sx={{
              marginLeft: currentState.widgetTitleAlignment === 'center' ? 1 : 0,
              fontSize: "1.2rem"
            }}>50%</Typography>}
      </Stack>
      <Box
        sx={{
          height: "50px",
          backgroundColor: theme.palette.grey[300]
        }}>
        <Box
          sx={{
            width: fillWidth,
            height: "100%",
            backgroundColor: fillColor
          }} />
      </Box>
    </Stack>
  );
}